// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscription-filter[data-v-0de4c339] {\n  width: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
